import { Component, Input } from '@angular/core';

@Component({
	selector: 'job-cell-header',
	template: require('./job-cell-header.html')
})
export class JobCellHeader {
	@Input() icon: string;
	@Input() imgSrc: string;
	@Input() text: string;
	@Input() isBorderBottom: boolean;
	@Input() files: File[];
	@Input() galleryHeader: boolean;

	constructor() {}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/common/job-cell-header/job-cell-header.ts